import React, { useState } from 'react';
import { researchAreas, experiments } from '../../data/products';
import { useReveal } from '../../hooks/useReveal';
import './TheLab.scss';

const TheLab = () => {
    const [ref, revealed] = useReveal({ threshold: 0.12 });
    const [hover, setHover] = useState(null);

    return (
        <section className="the-lab" id="lab" ref={ref}>
            <div className={`tl-inner ${revealed ? 'is-in' : ''}`}>
                <div className="tl-head">
                    <span className="tl-eyebrow">The Lab</span>
                    <div className="tl-manifesto">
                        <p>Not every experiment becomes a product.</p>
                        <p>Some become technology.</p>
                        <p>Some become infrastructure.</p>
                        <p>Some become lessons.</p>
                        <p className="tl-manifesto-last">Some become the next company.</p>
                    </div>
                </div>

                <div className="tl-body">
                    <div className="tl-col">
                        <h3 className="tl-col-title">Currently Exploring</h3>
                        <ul
                            className={`tl-areas ${hover !== null ? 'has-hover' : ''}`}
                            onMouseLeave={() => setHover(null)}
                        >
                            {researchAreas.map((area, i) => (
                                <li
                                    key={area.name}
                                    className={`tl-area ${hover === i ? 'is-hot' : ''}`}
                                    style={{ '--i': i }}
                                    onMouseEnter={() => setHover(i)}
                                >
                                    <span className="tl-area-index">
                                        {String(i + 1).padStart(2, '0')}
                                    </span>
                                    <span className="tl-area-name">{area.name}</span>
                                    <span className="tl-area-note">{area.note}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="tl-col tl-col-experiments">
                        <h3 className="tl-col-title">In the Lab</h3>
                        <ul className="tl-experiments">
                            {experiments.map((exp, i) => (
                                <li key={exp.code} className="tl-exp" style={{ '--i': i }}>
                                    <div className="tl-exp-top">
                                        <span className="tl-exp-code">{exp.code}</span>
                                        <span className="tl-exp-state">{exp.state}</span>
                                    </div>
                                    <p className="tl-exp-title">{exp.title}</p>
                                    <span className="tl-exp-field">{exp.field}</span>
                                </li>
                            ))}
                        </ul>
                        <p className="tl-exp-foot">
                            Details withheld until they ship.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TheLab;
